import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CodeSampleTab extends Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    setSampleLang: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.setSampleLang(this.props.name);
  }

  render() {
    return(
      <li className={this.props.selected ? 'active' : ''}>
        <a href="#" onClick={this.handleClick}>
          <img src={this.props.icon} style={{width:'100%', height: 'auto', objectFit: 'contain'}} />
        </a>
      </li>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/CodeSample/CodeSampleTab.js
 **/